import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ButtonPreview from './Preview';
import ButtonStyles from './Styles';
import DisabledButtonPreview from './DisabledButtonPreview';
import DisabledButtonStyles from './DisabledButtonStyles';
import LinksWithIconPreview from './LinksWithIconPreview';
import Spinner from './Spinner';
import IconLinkStyles from './IconLinkStyles';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { SparkTabs } from '../../../ui/spark';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import { range } from 'lodash';
import { RemFilter } from '../../../helpers/RemFilter';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { checkPermissionForLevel, checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';
import LinksPreviewWithStyles from './LinksPreviewWithStyles';

class ThemeButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 'medium'
        };
    }

    componentDidMount() {
        this.tabsElm = new SparkTabs(this.tabsNode);
    }

    render() {
        const lineHeight =
            this.state.size === 'medium'
                ? this.props.buttonStyles.medium.lineHeight
                : this.props.buttonStyles.small.lineHeight;
        let padding =
            this.state.size === 'medium'
                ? this.props.buttonStyles.medium.padding
                : this.props.buttonStyles.small.padding;
        let splitPadding = padding.split(' ').map(v => new RemFilter(v));
        //   const paddingParts = splitPadding.map(v => return newRemFilter(v))
        let paddingsPx = splitPadding.map(v => v.original.px.toString());
        const filteredLineHeight = new RemFilter(lineHeight);
        return (
            <div className="ThemeButtons Theme-Content">
                <h1>Buttons and Links</h1>
                <p className="normal-text">Select colors, fonts and styles for your buttons</p>
                <div className="subpages-main-content row">
                    <div ref={node => (this.tabsNode = node)} className="spark-tabs col-lg-12 col-xs-12">
                        <nav className="spark-tabs__nav" role="menubar">
                            <div className="spark-tabs__scroll">
                                <ul className="spark-tabs__list" role="tablist">
                                    <li className="spark-tabs__tab active text-center" role="tab">
                                        <a>Buttons</a>
                                    </li>
                                    <li className="spark-tabs__tab  text-center" role="tab">
                                        <a>Links</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="spark-tabs__btns">
                                <button className="spark-tabs__btn spark-icon-arrow-chevron-left spark-tabs__btn--left" />
                                <button className="spark-tabs__btn spark-icon-arrow-chevron-right spark-tabs__btn--right" />
                            </div>
                        </nav>
                        <div className="spark-tabs__panels">
                            <div role="tabpanel" className="spark-tabs__panel row">
                                <div className="spark-panel__content col-lg-12 col-xs-12">
                                    <h4>Button Size</h4>
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-3">
                                            <ReactSparkSelectInput
                                                label="Size"
                                                values={['medium', 'small'].map((v, k) => ({ key: v, label: v }))}
                                                onChange={event => {
                                                    this.setState({ size: event.target.value });
                                                }}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                defaultValue={this.state.size}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <ReactSparkSelectInput
                                                label="Height"
                                                values={range(40).map((v, k) => ({
                                                    key: `${v}px`.toString(),
                                                    label: `${v}px`.toString()
                                                }))}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onChange={this.props.onCssLengthChange(
                                                    `${this.state.size}.lineHeight`,
                                                    filteredLineHeight
                                                )}
                                                defaultValue={filteredLineHeight.original.px.toString()}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <ReactSparkSelectInput
                                                label="Top-Bottom Padding"
                                                values={range(40).map((v, k) => ({
                                                    key: `${v}px`.toString(),
                                                    label: `${v}px`.toString()
                                                }))}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onChange={this.props.onPaddingUpdate(splitPadding, this.state.size, 0)}
                                                defaultValue={paddingsPx[0]}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-lg-3">
                                            <ReactSparkSelectInput
                                                label="Left-Right Padding"
                                                values={range(40).map((v, k) => ({
                                                    key: `${v}px`.toString(),
                                                    label: `${v}px`.toString()
                                                }))}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onChange={this.props.onPaddingUpdate(splitPadding, this.state.size, 1)}
                                                defaultValue={paddingsPx[1]}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="spark-panel__content col-lg-12 col-xs-12">
                                            <ButtonPreview
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                tagNameName="Primary Button"
                                                spinner={<Spinner />}
                                                data={this.props.buttonStyles.primary}
                                                tag={'Select the button font, color and styles.'}
                                                buttonPreview={this.props.primary}
                                                layer="primary"
                                            />
                                            <ButtonStyles
                                                id=""
                                                tagNameName=""
                                                layer="primary"
                                                tagName="general"
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                fontData={this.props.primary}
                                                data={this.props.buttonStyles.primary}
                                            />
                                        </div>
                                        <div className="spark-panel__content col-lg-12 col-xs-12">
                                            <ButtonPreview
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                tagNameName="Secondary Button"
                                                data={this.props.buttonStyles.secondary}
                                                buttonPreview={this.props.secondary}
                                                layer="secondary"
                                                tag={'Select the button font, color and styles.'}
                                            />
                                            <ButtonStyles
                                                id=""
                                                tagNameName=""
                                                layer="secondary"
                                                tagName="general"
                                                fontData={this.props.secondary}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                data={this.props.buttonStyles.secondary}
                                            />
                                        </div>
                                        <div className="spark-panel__content col-lg-12 col-xs-12">
                                            <DisabledButtonPreview
                                                tagNameName="Disabled Button"
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                buttonPreview={this.props.buttonStyles.primary}
                                                data={this.props.buttonStyles.primary}
                                                colors={this.props.buttonStyles.disabled}
                                                layer="disabled"
                                                tag={'Select the button color and border styles.'}
                                            />
                                            <DisabledButtonStyles
                                                id=""
                                                tagNameName=""
                                                layer="disabled"
                                                tagName="general"
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                data={this.props.buttonStyles.primary}
                                                colors={this.props.buttonStyles.disabled}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div role="tabpanel" className="spark-tabs__panel row">
                                <div className="spark-panel__content col-lg-12 col-xs-12">
                                    <LinksPreviewWithStyles
                                        data={this.props.links}
                                        fontStyle={this.props.fontStyles}
                                        isDisabled={!this.props.hasPermissionThemesEdit}
                                        layer="link"
                                        tag={''}
                                        tagNameName="Text Links"
                                        styleStates={['default', 'hover', 'active', 'focus']}
                                    />
                                </div>
                                <div className="spark-panel__content col-lg-12 col-xs-12">
                                    <LinksPreviewWithStyles
                                        data={this.props.links.highlight}
                                        fontStyle={this.props.fontStyles}
                                        isDisabled={!this.props.hasPermissionThemesEdit}
                                        layer="link.highlight"
                                        tag={''}
                                        tagNameName="Highlight Links"
                                        styleStates={['normal', 'hover', 'active']}
                                    />
                                </div>
                                <div className="spark-panel__content col-lg-12 col-xs-12">
                                    <IconLinkStyles
                                        id=""
                                        tagNameName="Text Link with Icon"
                                        layer="primary"
                                        tagName="general"
                                        fontData={this.props.primary}
                                        colors={this.props.buttonStyles.link}
                                        isDisabled={!this.props.hasPermissionThemesEdit}
                                    >
                                        <LinksWithIconPreview
                                            tagNameName=""
                                            buttonPreview={this.props.secondary}
                                            colors={this.props.buttonStyles.link}
                                            layer="secondary"
                                            tag={''}
                                        />
                                    </IconLinkStyles>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeButtons.propTypes = {
    children: PropTypes.element
};

const mapThemeButtonsStateToProps = state => {
    return {
        ...state.app.data.theme.buttons,
        ...state.theme.buttons,
        links: state.app.data.theme.links,
        buttonStyles: state.app.data.theme.buttons.button,
        fontStyles: state.app.data.theme.global.font,
        hasPermissionThemesEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPaddingUpdate: (paddingFilters, size, index) => {
            const converted = paddingFilters.map(v => v.original.raw.toString());
            return event => {
                converted[index] = paddingFilters[index].filter(event.target.value);
                return dispatch(ThemeActions.modifyThemeKey(`buttons.button.${size}.padding`, converted.join(' ')));
            };
        },
        onCssLengthChange: onCssLengthChange(dispatch, 'buttons.button')
    };
};

export default connect(mapThemeButtonsStateToProps, mapDispatchToProps)(ThemeButtons);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/index.js